// The ONE app-tile primitive — the geex squircle every launcher surface
// shares: home-board icon mode, the header search-dropdown springboard, and
// anything that lists apps. Radius sits on the B1 squircle step, the board's
// smoothness scale.
//
// ── TWO SURFACES, TWO RESOLVERS ──────────────────────────────────────────
// Nika 2026-09-02: "on / page widgets, make solid - a default color for all
// of them", then, on the first pass: "pipeline still has color and set to no
// color also does not change it. fix it fundamentally for also all app-store
// related apps and widgets too".
//
// A home-board tile is part of a WIDGET, so it follows that widget's colour:
// NEUTRAL until the user picks one — for every plane, including an app-store
// module widget that declares its own manifest hue. A launcher row is not a
// widget; it is the app's identity inside a menu, so it keeps the house
// catalog (and a module's manifest hue) exactly as before.
//
// The two are told apart by which prop the mount site passes, which is how
// they already differed and needs no new flag:
//   • `hueId` (a widget id, or a module widget's open route) → HOME BOARD →
//     `homeWidgetSurfaceHue`: the user's pick, or neutral. NOTHING else.
//   • `s.route` only (SearchAppsMenu's springboard rows) → LAUNCHER →
//     `homeWidgetHue`: the house catalog ▸ manifest hue ▸ neutral.
//
// ⚠️ The board branch no longer forwards `s.hue`/`s.iconBg` as a fallback.
// That forward was the defect: it repainted a module widget's manifest hue
// the moment the user cleared their colour, so "Default (no color)" looked
// inert on exactly the widgets an installed app contributes. The manifest hue
// is still reachable — the palette offers it as its first swatch ("App
// color", `homeWidgetAppColorOption`) — it is just no longer a default.
//
// `colorId` — OPTIONAL, home board only. The widget id the USER's colour is
// keyed by, when that differs from `hueId`. A module widget resolves its
// manifest hue by OPEN ROUTE (`hueId`) but is colour-picked by WIDGET ID, and
// without this the picked colour would be written under one key and looked up
// under another. Static widgets pass `hueId: spec.id` — already the widget id
// — so they need nothing.
//
// Unmapped and un-picked tiles fall back to the adaptive overlayStrong/title
// pair — never a gradient or dead literal (the search menu's raw-hex
// TILE_GRADIENTS were this tile's predecessor and are gone).
//
// `el.context.designSystem` is threaded to both resolvers so a RAW hue — a
// manifest hue on the launcher, or one the user picked from the "App color"
// row on the board — gets a MEASURED binary ink (tickets/fable.md) instead of
// the historical white-ink guess.
export const AppHueTile = {
  align: 'center center',
  width: 'D1',
  height: 'D1',
  minWidth: 'D1',
  round: 'B1',
  background: (el, s) => {
    const h = el.hueId
      ? el.call(
          'homeWidgetSurfaceHue',
          el.state?.root,
          el.colorId || el.hueId,
          el.context.designSystem
        )
      : el.call(
          'homeWidgetHue',
          s.route,
          s.hue || s.iconBg || s.spec?.iconBg,
          el.context.designSystem
        )
    return (h && h.bg) || 'overlayStrong'
  },
  color: (el, s) => {
    const h = el.hueId
      ? el.call(
          'homeWidgetSurfaceHue',
          el.state?.root,
          el.colorId || el.hueId,
          el.context.designSystem
        )
      : el.call(
          'homeWidgetHue',
          s.route,
          s.hue || s.iconBg || s.spec?.iconBg,
          el.context.designSystem
        )
    return (h && h.ink) || 'title'
  },
  Icon: {
    icon: (el, s) => el.parent.icon || s.icon || 'star',
    boxSize: 'B',
    color: (el, s) => {
      const h = el.parent.hueId
        ? el.call(
            'homeWidgetSurfaceHue',
            el.state?.root,
            el.parent.colorId || el.parent.hueId,
            el.context.designSystem
          )
        : el.call(
            'homeWidgetHue',
            s.route,
            s.hue || s.iconBg || s.spec?.iconBg,
            el.context.designSystem
          )
      return (h && h.ink) || 'title'
    }
  }
}
